<template>
    <div class="wa-status-modal">
        <SOSlotModal :modal-title="`Upload Status WA`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="f-16 f-regular f-c-black md-content">
                    <div class="d-flex list-container">
                        <div>
                            <svg
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M4 2.5H14C15.1046 2.5 16 3.39543 16 4.5V10.0858L15.7071 9.79289L15.6934 9.77942C15.091 9.19979 14.3358 8.83013 13.5 8.83013C12.6642 8.83013 11.909 9.19979 11.3066 9.77942L11.2929 9.79289L11 10.0858L8.70711 7.79289L8.69337 7.77942C8.091 7.19979 7.33581 6.83013 6.5 6.83013C5.66419 6.83013 4.909 7.19979 4.30662 7.77942L4.29289 7.79289L2 10.0858V4.5C2 3.39543 2.89543 2.5 4 2.5ZM18 12.499V4.5C18 2.29086 16.2091 0.5 14 0.5H4C1.79086 0.5 0 2.29086 0 4.5V12.4998C0 12.4997 0 12.4999 0 12.4998V14.5C0 16.7091 1.79086 18.5 4 18.5H14C16.2091 18.5 18 16.7091 18 14.5V12.501C18 12.5003 18 12.4997 18 12.499ZM16 12.9142V14.5C16 15.6046 15.1046 16.5 14 16.5H4C2.89543 16.5 2 15.6046 2 14.5V12.9142L5.69966 9.21456C6.00689 8.92128 6.28406 8.83013 6.5 8.83013C6.71594 8.83013 6.99311 8.92128 7.30034 9.21456L12.2929 14.2071C12.6834 14.5976 13.3166 14.5976 13.7071 14.2071C14.0976 13.8166 14.0976 13.1834 13.7071 12.7929L12.4142 11.5L12.6997 11.2146C13.0069 10.9213 13.2841 10.8301 13.5 10.8301C13.7159 10.8301 13.9931 10.9213 14.3003 11.2146L16 12.9142ZM11 5.5C11 4.94772 11.4477 4.5 12 4.5H12.01C12.5623 4.5 13.01 4.94772 13.01 5.5C13.01 6.05228 12.5623 6.5 12.01 6.5H12C11.4477 6.5 11 6.05228 11 5.5Z"
                                    fill="#206CFF"
                                />
                            </svg>
                        </div>
                        <div>
                            <p class="m-d-0 f-c-black f-16 f-semi">Foto</p>
                            <p class="m-d-0 f-c-midgrey f-14 f-regular">Ambil dari kamera atau galeri</p>
                        </div>
                        <input
                            type="file"
                            id="images"
                            accept="image/png, image/gif, image/jpeg"
                            class="input-file"
                            @change="filesChange"
                        />
                    </div>
                    <div class="d-flex list-container">
                        <div>
                            <svg
                                width="11"
                                height="15"
                                viewBox="0 0 11 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M0 0.640137V14.6401L11 7.64014L0 0.640137Z" fill="#206CFF" />
                            </svg>
                        </div>
                        <div>
                            <p class="m-d-0 f-c-black f-16 f-semi">Video</p>
                            <p class="m-d-0 f-c-midgrey f-14 f-regular">Maksimal durasi 30 detik</p>
                        </div>
                        <input type="file" id="images" accept="video/*" class="input-file" @change="filesChange" />
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";

import { moduleName } from "../../store/state";

export default {
    name: "UploadModal",
    components: {
        SOSlotModal,
    },
    data() {
        return {
            backLink: "wa_status.create_status",
            modalId: "upload-file",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    methods: {
        ...mapActions({
            setFileUpload: `${moduleName}/setFileUpload`,
        }),
        async back() {
            this.$router.go(-1);
        },
        setBackLink(val) {
            this.backLink = val;
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        async filesChange(obj) {
            await this.setFileUpload(obj.target.files[0]);
            await this.back();
        },
    },
};
</script>
<style scoped>
.list-container {
    align-items: center;
    position: relative;
    padding: 16px 20px;
    margin-left: -18px;
    margin-right: -18px;
    border-top: 1px solid #edeeed;
}

.list-container div:nth-child(1) {
    min-width: 30px;
}

.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 100%;
    position: absolute;
    cursor: pointer;
}
</style>
